// extracted by mini-css-extract-plugin
export default {"color_btn":"ColorButton_color_btn__SqRYB","selected_color_btn":"ColorButton_selected_color_btn__YS5lY"};